module.exports = __webpack_public_path__ + "static/media/KGantin-96-1.f67abb3c.jpg";